import { useState, useContext } from "react";
import { AuthContext } from "../context/authContext";
import { Link } from "react-router-dom";
import Carging from "../components/Carging";

import Firma from "../components/Firma";

const Forgot = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const { resertPassword } = useContext(AuthContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        resertPassword(email)
            .then(() => {
                setIsLoading(false);
                alert("A email was sent to you with a link to reset your password");
            })
            .catch((error) => {
                setError(error.message);
                setIsLoading(false);
            })
    }



    return (
        <div className="h100 bg-primary d-flex">
            <div className="col-4  h-100 d-none  d-md-flex flex-column align-items-center justify-content-center">
                <h3 className="fs-3"><Firma bg={"dark"} /></h3>
                <small className="text-white">Aministración el sistema</small>
            </div>
            <div
                className="flex-grow-1 h-100 bg-light rounded-start shadow-lg d-flex flex-column justify-content-center align-items-center"
            >
                <form onSubmit={(e) => handleSubmit(e)}>
                    <h4 className="mb-5 text-center d-flex d-md-none">
                        <Firma />
                    </h4>
                    <h4
                        className="fs-2">
                        Forgot your password?
                    </h4>
                    <small className="mb-5">
                        Please enter your email address to get your password reset instructions
                    </small>
                    <div className="form-floating my-3">
                        <input
                            autoComplete="off"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); setError('') }}
                            type="email"
                            className={`form-control ${error ? "is-invalid" : ""}`}
                            id="floatingInput"
                            placeholder="name@example.com"
                            required
                        />
                        <label htmlFor="floatingInput">Email address</label>
                    </div>                
                    <div className="form-floating my-3 text-end">
                        <Link to="/admin" className="n-link">Back to login</Link>
                    </div>
                    {error ? <small className="text-danger">{error}</small> : <small>&nbsp;</small>}
                    <button
                        disabled = {isLoading}
                        className={`btn btn-primary justify-content-around d-flex align-items-center col-12 ${isLoading ? "disabled" : ""}`}
                        onClick={() => {
                            if (email.length > 0) {
                                setError('');
                            } else {
                                setError('Email is required');
                            }
                        }}
                    >
                        <span>Send</span>
                        {Carging ? <span><i className="bi bi-send"></i></span> : <Carging />}
                    </button>
                </form>
            </div>
        </div>
    )

}
export default Forgot;
